import Button from "@components/ui/Button";
import ErrorBanner from "@components/shared/ErrorBanner";
import Table, {
  TableBody, TableCell, TableHead, TableHeaderCell, TableRow,
} from "@components/ui/Table";

/**
 * Patients no campaign and no manual call may reach.
 *
 * A patient who declines on a call is flagged automatically; staff can flag one
 * from the call list. Only a person can clear it. The endpoint returns the PMS
 * patient id and nothing else, so that is what a row can show.
 */
export default function DoNotCallList({ patients, error, onDismissError, onAllowCalls }) {
  const rows = patients || [];

  return (
    <div className="space-y-3">
      {/* A failed load, or a failed "Allow calls", is reported here in the
          section it belongs to rather than at the top of the page. */}
      <ErrorBanner message={error} onDismiss={onDismissError} />

      {rows.length === 0 && !error && (
        // Never claim the list is empty after a failed request: that is a
        // statement about the clinic's patients we have no basis to make.
        <p className="text-sm text-gray-600">
          No one is on the do-not-call list. A patient who declines on a call is added here
          automatically.
        </p>
      )}

      {rows.length > 0 && (
        <Table>
          <TableHead>
            <TableRow>
              <TableHeaderCell>Patient</TableHeaderCell>
              <TableHeaderCell>Why</TableHeaderCell>
              <TableHeaderCell>Since</TableHeaderCell>
              <TableHeaderCell className="w-32">
                <span className="sr-only">Actions</span>
              </TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((patient) => (
              <TableRow key={patient.external_patient_id}>
                <TableCell className="text-sm text-gray-900">
                  {patient.external_patient_id}
                </TableCell>
                <TableCell className="text-sm text-gray-600">
                  {patient.do_not_call_reason || "No reason recorded"}
                  <span className="block text-xs text-gray-400">
                    {patient.do_not_call_set_by_user_id
                      ? "Set by a colleague"
                      : "Set automatically"}
                  </span>
                </TableCell>
                <TableCell className="text-sm text-gray-600">
                  {patient.do_not_call_set_at
                    ? new Date(patient.do_not_call_set_at).toLocaleDateString()
                    : ""}
                </TableCell>
                <TableCell>
                  <Button color="light" size="xs"
                          aria-label={`Allow calls to ${patient.external_patient_id}`}
                          onClick={() => onAllowCalls(patient.external_patient_id)}>
                    Allow calls
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
